import { DataPackSelectItem } from "./DataPackSelectItem.model";

/**
 * @author Thiago Neri
 * @version $Id$
 */
export class DataPackService {
  
  public id: number;
  public serviceState: string;
	public serviceType: string;
  public serviceName: string; 
  public serviceCode: string;
  public memberInfo: string;
  public editable: boolean;
  public carriersListAll: Array<DataPackSelectItem> = new Array<DataPackSelectItem>();
  public carriersList: Array<DataPackSelectItem> = new Array<DataPackSelectItem>();
  public carriersListSelected: Array<DataPackSelectItem> = new Array<DataPackSelectItem>();
  public allowedNumber: Array<DataPackSelectItem> = new Array<DataPackSelectItem>();
  public blockedNumber: Array<DataPackSelectItem> = new Array<DataPackSelectItem>();
  public allowInheritance: boolean;
  
  public constructor() {
      
  }
}




// WEBPACK FOOTER //
// ./src/app/models/DataPackService.model.ts